import React from 'react';
import './nlp.css';

const m_wywl = () => {
    const state = {
        wywl_item: [
            {
                text: `Natural Language Processing`,
            },
            {
                text: `NLP Transformers`,
            },
            {
                text: `Pre-trained Models`,
            },
            {
                text: `Text Analytics`,
            },
            {
                text: `Natural Language Understanding`,
            },
            {
                text: `Sentiment Analysis`,
            },
            {
                text: `Natural Language Generation`,
            },
            {
                text: `Speech Recognition`,
            },
            {
                text: `Named Entity Extraction`,
            },
      ],
    };

    const renderWYWL = (item, i) => {
        return (
            <div className="m_wywl_item">
                <p className="m_wywl_text inner_pages--text">{item.text}</p>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">Topics</h3>
                <div className="m_wywl_blocks">
                    {state.wywl_item.map((item, i) => renderWYWL(item, i))}
                </div>
            </div>
        </div>
    );
};

export default m_wywl;